module.exports = __webpack_public_path__ + "img/jacobsen_En_folkekjaer_modernist1.3c7a6416.jpg";